import { render, staticRenderFns } from "./ShowcaseForm.vue?vue&type=template&id=3b812222&"
import script from "./ShowcaseForm.vue?vue&type=script&lang=js&"
export * from "./ShowcaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports